import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '@common/common.action';
import * as kanbanActions from '../../../componentes/dragdrog/store/kanban.action';
import * as organizarActions from '../../../componentes/dragdrog/organizarLote/store/organizar.action';
import cloneDeep from 'lodash/cloneDeep';
import LaminasPage from './laminas.page';
import HistologiaApi from '../common/histologia.api';
import { getUsuarioLocalStorage, setOrdenacaoKanban, getOrdenacaoKanban } from '../../../localStorage.util';
import UteisHistologia from './laminas.util';
import WebapiCommon from '@common/util/webapi.common';
import CommonFunctions from '@common/util/functions.common';
import { quadroKanbanEnum, colorsSystem } from '@common/util/defaultValues';
import Preview from '@componentes/PreviewURL';
import Card from './Card';
import { changePeriod, getDate, obterListagemDePeriodos, validarData } from '../../../helpers';

class LaminasContainer extends Component {
	constructor(props) {
		super(props);
		this.usuario = getUsuarioLocalStorage();

		const periodo = CommonFunctions.getPeriodosSubDays(0);

		this.state = {
			lista: UteisHistologia.getInicialKanbam(),
			modalOpen: false,
			modalOpenCancelar: false,
			modalOpenNaoConfor: false,
			modalHistologiaBlocos: false,
			naoconformidades: false,
			exibirNaoConformidadeNoLaudo: false,
			modalDroppableId: '',
			blocoSelecionado: undefined,
			laminasSelecionadas: UteisHistologia.getInicialLaminas(),
			enableSentinela: false,
			tipoLaminaBloco: undefined,
			tecnicos: [],
			tecnicoSelecionado: null,
			tecnicoModalSelecionado: null,
			medicos: [],
			medicoSelecionado: null,
			periodoInicial: periodo.periodoInicial,
			periodoFinal: periodo.periodoFinal,
			itemInModal: {
				label: '',
				etapa: 1
			},
			numeroDoExame: '',
			numeroDoPedido: '',
			altura: '',
			showModalImprimirEtiquetaEmLote: false,
			laminasParaEtiqueta: [],
			usuarioLocal: this.usuario,
			mudou: false,
			show: false,
			url: '',
			periodo: { value: 'hoje', label: `${this.props.intl.formatMessage({ id: "period.today" })}` },
			periodos: [],
			sortAsc : getOrdenacaoKanban()
		};

		this.getDate = getDate.bind(this);
		this.changePeriod = changePeriod.bind(this);
		this.obterListagemDePeriodos = obterListagemDePeriodos.bind(this);
		this.validarData = validarData.bind(this);
		this.periodoAlterado({ value: 'hoje', label: `${this.props.intl.formatMessage({ id: "period.today" })}` });

	}

	componentDidMount() {
		let usuarioLocalStorage = getUsuarioLocalStorage();
		if (usuarioLocalStorage === null) {
			this.props.commonActions.showFadeCarregando(false);
			this.props.history.push('/' + process.env.REACT_APP_LOGINPAGE);
		} else {
			var promises = [
				HistologiaApi.getUsuario(),
				WebapiCommon.getMedicos(),
				WebapiCommon.getNaoConformidades(),
				WebapiCommon.getConfiguracaoMapaMacroscopico()
			];

			Promise.all(promises).then(result => {
				let altura = window.innerHeight - 187 + 60 + 'px';

				this.setState({
					tecnicos: [{ value: null, label: `${this.props.intl.formatMessage({ id: "dashboards.cytology.technical" })}` }, ...result[0]],
					tecnicoSelecionado: { value: null, label: `${this.props.intl.formatMessage({ id: "dashboards.cytology.technical" })}` },
					medicos: result[1],
					naoconformidades: result[2],
					usuario: usuarioLocalStorage,
					usuarioLocal: usuarioLocalStorage,
					altura
				});

				let configMacro = result[3];

				if (configMacro) {
					let medicoPadrao = configMacro.configuracoesMapaMacroscopicoItems.find(
						el => el.coluna === 'Cd_med_padrao_macro'
					);

					if (medicoPadrao) {
						this.props.commonActions.medicoPadraoMacroscopia(
							medicoPadrao.valor
						);
					}
				}

				this.props.commonActions.showFadeCarregando(true);

				this.filtrar(
					null,
					this.state.periodoInicial,
					this.state.periodoFinal,
					this.state.numeroDoExame,
					this.state.numeroDoPedido,
					this.state.sortAsc
				);
			});
		}

		this.setState({periodos: this.obterListagemDePeriodos(this.props.intl)});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.sortAsc !== prevState.sortAsc) {
			setOrdenacaoKanban(this.state.sortAsc);
		  this.buscar();
		}

		if (this.state.mudou) {
			this.setState({ mudou: false });
			this.buscar();
		}

		if (this.props.novasLaminas) {
			this.props.kanbanActions.atualizarNovasLaminas(false);
			this.props.commonActions.showFadeCarregando(true);
			//let data = CommonFunctions.getPeriodosSubDays();
			this.setState({
				//periodoInicial: data.periodoInicial,
				//periodoFinal: data.periodoFinal,
				mudou: true
			});
		}
		if (this.props.organizarLotenovasLaminas) {
			this.props.organizarActions.atualizarNovasLaminas(false);
			this.props.commonActions.showFadeCarregando(true);
			//let data = CommonFunctions.getPeriodosSubDays();
			this.setState({
				//periodoInicial: data.periodoInicial,
				//periodoFinal: data.periodoFinal,
				mudou: true
			});
		}
	}

	resetarPeriodo = () => {
		this.setState({periodo: '', periodoInicial: null, periodoFinal: null})
	}

	periodoAlterado = (e) => {
		if (!e || !e.value) {
		  return this.resetarPeriodo();
		}

		let payload = this.getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

		this.setState({
			periodo: e,
			periodoInicial: payload.dtinicial,
			periodoFinal: payload.dtfinal})
	}

	mudarIntervaloPeriodo = (val) => {
		let payload = this.changePeriod(val);

		this.setState({
			periodoInicial: payload.start,
			periodoFinal: payload.end})
	}

	eventoOnKeyPressData(event) {
		if (event.key === "Enter")
			this.buscar();
	}

	modalEditBlocoControl() {
		this.setState({
			modalHistologiaBlocos: !this.state.modalHistologiaBlocos
		})
	}

	montemItemKanbanBloco(cassete, icone, etapa) {
		const id = `cassete_${cassete.id}`;
		return {
			id,
			data: cassete,
			isDragDisabled: cassete.bloqueado === 'S',
			content: (
				<Card
					id={id}
					label={cassete.nrBloco}
					material={cassete.nomeMaterial}
					item={cassete}
					icone={icone}
					etapa={etapa}
					type='cassete'
					setState={this.setState.bind(this)}
					openModal={this.openModal.bind(this)}
					openModalBlocos={this.modalEditBlocoControl.bind(this)}
					imprimirEtiquetaIndividual={this.imprimirEtiquetaIndividual.bind(
						this
					)}
				/>
			)
		};
	}

	montemItemKanbanLamina(lamina, icone, etapa) {
		const id = `lamina_${lamina.idBlocoLamina}_${lamina.id}_${etapa}`;
		return {
			id,
			data: lamina,
			isDragDisabled: lamina.bloqueado === 'S',
			content: (
				<Card
					id={id}
					label={lamina.nrLamina}
					material={lamina.tipoLamina}
					item={lamina}
					icone={icone}
					etapa={etapa}
					type='lamina'
					setState={this.setState.bind(this)}
					openModal={this.openModal.bind(this)}
					openModalBlocos={this.modalEditBlocoControl.bind(this)}
					imprimirEtiquetaIndividual={this.imprimirEtiquetaIndividual.bind(
						this
					)}
				/>
			)
		};
	}

	setShow(show) {
		this.setState({ show });

		if (!show && this.state.showModalImprimirEtiquetaEmLote) {
			this.toggleModalImprimirEtiquetaEmLote();
		}
	}

	imprimirEtiquetaIndividual(item) {
		this.props.commonActions.showFadeCarregando(true);
		let etiquetas = [];
		etiquetas.push({
			tipoItem: item.nrLamina ? `${this.props.intl.formatMessage({ id: "dashboards.taskControl.blade" })}` : `${this.props.intl.formatMessage({ id: "dashboards.examDetail.block" })}`,
			codigoBarra: item.nrLamina ? item.nrLamina : item.nrBloco,
			numeroExame: item.numeroExame,
			nomePaciente: item.nomePaciente,
			numeroAtendimento: item.cdLaudo.toString(),
			numeroPedido: item.numeroPedido.toString(),
			recebidoEm: item.dataDeCadastro,
			coloracao: item.coloracao,
			complemento: item.complemento,
			impressora: 'clawPDF',
			modelo: 'areatecnica'
		});

		WebapiCommon.imprimirEtiquetaAreaTecnica(etiquetas).then(data => {
			var url = CommonFunctions.getPdfBlob(data.pdf);
			this.props.commonActions.showFadeCarregando(false);
			this.setState({ url: url });
			this.setShow(!this.state.show);
		});
	}

	limparFiltro() {
		this.setState({
			periodoInicial: null,
			periodoFinal: null,
			periodo: '',
			tecnicoSelecionado: null,
			numeroDoExame: '',
			numeroDoPedido: '',
			laudoPesquisa: '',
			lista: []
		});
	}

	toggleModalImprimirEtiquetaEmLote = () =>
		this.setState(state => ({
			showModalImprimirEtiquetaEmLote: !state.showModalImprimirEtiquetaEmLote
		}));

	imprimirEtiquetaEmLote(laminasMarcadas) {
		this.props.commonActions.showFadeCarregando(true);
		let laminas = [];

		laminasMarcadas.map(el => {
			let laminasParaEtiqueta = this.state.laminasParaEtiqueta;
			let lamina = laminasParaEtiqueta.find(la => la.idLamina === el);

			laminas.push({
				impressora: 'clawPDF',
				codigoBarra: lamina.lamina,
				numeroExame: lamina.numeroExame,
				numeroPedido: lamina.numeroPedido.toString(),
				numeroAtendimento: lamina.numeroAtendimento,
				nomePaciente: lamina.nomePaciente,
				complemento: lamina.complemento,
				modelo: 'areatecnica'
			});

			return lamina;
		});

		WebapiCommon.imprimirEtiquetaAreaTecnica(laminas).then(data => {
			var url = CommonFunctions.getPdfBlob(data.pdf);
			this.props.commonActions.showFadeCarregando(false);
			this.setState({ url: url });
			this.setShow(!this.state.show);
		});
	}

	openModal(identificador, nomeEtapa, modal) {
		var etapas = {
			blocos: 0,
			pendente: 1,
			executando: 2,
			laminas: 3
		};
		var bloco = this.state.lista[etapas[nomeEtapa]][nomeEtapa].find(b => {
			return b.id === identificador;
		});

		var exc = {
			id: bloco.data.id,
			label:
				bloco.data.nrBloco !== undefined
					? bloco.data.nrBloco
					: bloco.data.nrLamina,
			etapa: bloco.data.nrBloco !== undefined ? 1 : 2
		};
		this.setState({
			itemInModal: exc
		});

		if (modal === 'cancelar') {
			this.toggleModalCancelar();
		} else {
			this.toggleModalNaoConfor();
		}
	}

	buscar() {
		if ((!this.state.tecnicoSelecionado || this.state.tecnicoSelecionado.value == null) &&
			this.state.numeroDoExame == '' &&
			this.state.numeroDoPedido == '' &&
			((this.state.periodoInicial == null) || this.state.periodoInicial == '') &&
			((this.state.periodoFinal == null) || this.state.periodoFinal == '')) {
				this.props.commonActions.showAlerta('alerta', this.props.intl.formatMessage({id: 'dashboards.general.noFilteredItems'}), 3000);
			return;
		}

		let executarValidacaoDeData =
			((this.state.periodoInicial != null) && this.state.periodoInicial != '') ||
			((this.state.periodoFinal != null) && this.state.periodoFinal != '');
		let datasValidas = !executarValidacaoDeData ? true :
			this.validarData(this.state.periodoInicial, this.state.periodoFinal, this.props.intl, this.props.commonActions);

		if (datasValidas) {
			this.props.commonActions.showFadeCarregando(true);
			this.filtrar(
				this.state.tecnicoSelecionado && this.state.tecnicoSelecionado.value,
				this.state.periodoInicial,
				this.state.periodoFinal,
				this.state.numeroDoExame,
				this.state.numeroDoPedido,
				this.state.sortAsc
			);
		}
	}

	organizar() {
		this.props.organizarActions.atualizarModal(true);
	}

	onChangeData(name, value) {
		this.setState({[name]: value});
	}

	onChangeTecnico(tecnico) {
		this.setState({tecnicoSelecionado: tecnico});
	}

	filtrar(tecnico, dataInicial, dataFinal, numeroDoExame, numeroDoPedido, sortAsc) {
		// if (sortAsc === null || sortAsc === undefined) {
		// 	sortAsc = false;
		// }

		let lista = [];

		var promises = [
			HistologiaApi.getBlocos(tecnico, dataInicial, dataFinal, numeroDoExame, numeroDoPedido, sortAsc),
			HistologiaApi.getLaminas(tecnico, dataInicial, dataFinal, numeroDoExame, numeroDoPedido, sortAsc)
		];

		this.props.commonActions.showFadeCarregando(true);

		Promise.all(promises).then(result => {
			this.props.commonActions.showFadeCarregando(false);

			lista.push({
				blocos: result[0].finalizado.map(bloco =>
					this.montemItemKanbanBloco(
						bloco,
						quadroKanbanEnum.HL_BLOCOS.icone,
						quadroKanbanEnum.HL_BLOCOS.id
					)
				),
				title: {
					text: `${this.props.intl.formatMessage({ id: "dashboards.taskControl.blocks" })}`,
					color: colorsSystem.DG1
				},
				count: result[0].finalizado.length
			});

			lista.push({
				pendente: result[1].naoRealizado.map(pendente =>
					this.montemItemKanbanLamina(
						pendente,
						quadroKanbanEnum.HL_PENDENTES.icone,
						quadroKanbanEnum.HL_PENDENTES.id
					)
				),
				title: {
					text: `${this.props.intl.formatMessage({ id: "dashboards.cytology.danglingBlades" })}`,
					color: colorsSystem.DG2
				},
				count: result[1].naoRealizado.length
			});

			lista.push({
				executando: result[1].andamento.map(executando =>
					this.montemItemKanbanLamina(
						executando,
						quadroKanbanEnum.HL_EXECUTANDO.icone,
						quadroKanbanEnum.HL_EXECUTANDO.id
					)
				),
				title: {
					text: `${this.props.intl.formatMessage({ id: "dashboards.cytology.bladesInProgress" })}`,
					color: colorsSystem.DG3
				},
				count: result[1].andamento.length
			});

			lista.push({
				laminas: result[1].finalizado.map(pronta =>
					this.montemItemKanbanLamina(
						pronta,
						quadroKanbanEnum.HL_PRONTAS.icone,
						quadroKanbanEnum.HL_PRONTAS.id
					)
				),
				title: {
					text: `${this.props.intl.formatMessage({ id: "dashboards.cytology.bladesReady" })}`,
					color: colorsSystem.DG5
				},
				count: result[1].finalizado.length
			});

			let altura = this.calcularAlturaColunaKanbam(lista);

			if (
				result[0].finalizado.length === 0 &&
				result[1].naoRealizado.length === 0 &&
				result[1].andamento.length === 0 &&
				result[1].finalizado.length === 0
			) {
				this.props.commonActions.showAlerta(
					'alerta',
					`${this.props.intl.formatMessage({ id: "dashboards.reports.noResultsFound" })}`,
					1500
				);
			}

			let laminasParaEtiqueta = [];
			// ANATOWEB-3501
			// result[0].finalizado.map(el =>
			// 	laminasParaEtiqueta.push({
			// 		idLamina: el.id,
			// 		finalizacao: el.status === quadroKanbanEnum.HL_PRONTAS.status,
			// 		lamina: el.nrBloco
			// 	})
			// );

			result[1].naoRealizado.map(el =>
				laminasParaEtiqueta.push({
					idLamina: el.id,
					finalizacao: el.status === quadroKanbanEnum.HL_PRONTAS.status,
					lamina: el.nrLamina,
					numeroPedido: el.numeroPedido,
					nomePaciente: el.nomePaciente,
					numeroExame: el.numeroExame,
					numeroAtendimento: el.cdLaudo.toString(),
					complemento: el.complemento
				})
			);

			result[1].andamento.map(el =>
				laminasParaEtiqueta.push({
					idLamina: el.id,
					finalizacao: el.status === quadroKanbanEnum.HL_PRONTAS.status,
					lamina: el.nrLamina,
					numeroPedido: el.numeroPedido,
					nomePaciente: el.nomePaciente,
					numeroExame: el.numeroExame,
					numeroAtendimento: el.cdLaudo.toString(),
					complemento: el.complemento
				})
			);

			result[1].finalizado.map(el =>
				laminasParaEtiqueta.push({
					idLamina: el.id,
					finalizacao: el.status === quadroKanbanEnum.HL_PRONTAS.status,
					lamina: el.nrLamina,
					numeroPedido: el.numeroPedido,
					nomePaciente: el.nomePaciente,
					numeroExame: el.numeroExame,
					numeroAtendimento: el.cdLaudo.toString(),
					complemento: el.complemento
				})
			);

			this.setState({
				lista,
				altura,
				laminasParaEtiqueta
			});
		});
	}

	calcularAlturaColunaKanbam = lista => {
		let bloco = lista[0].blocos;
		let pendente = lista[1].pendente;
		let executando = lista[2].executando;
		let finalizado = lista[3].laminas;

		let alturaNavbarFiltroEhTitulos = 230;
		let alturaExtraNoFinalDaColunaParaAreaDeDrop = 220;
		let colunaMaiorTotalItens = bloco.length;

		colunaMaiorTotalItens =
			pendente.length > colunaMaiorTotalItens
				? pendente
				: colunaMaiorTotalItens;

		colunaMaiorTotalItens =
			executando.length > colunaMaiorTotalItens
				? executando.length
				: colunaMaiorTotalItens;

		colunaMaiorTotalItens =
			finalizado.length > colunaMaiorTotalItens
				? finalizado.length
				: colunaMaiorTotalItens;

		let altura =
			alturaNavbarFiltroEhTitulos +
			alturaExtraNoFinalDaColunaParaAreaDeDrop +
			colunaMaiorTotalItens * 90 +
			'px';

		return altura;
	};

	onDragEndOverride(result) {
		const { source, destination } = result;
		var origem = {
			blocos: 0,
			pendente: 1,
			executando: 2,
			laminas: 3
		};

		var bloco = this.state.lista[origem[source.droppableId]][
			source.droppableId
		][source.index];
		if (source && destination) {
			if (source.droppableId === destination.droppableId) {
				// reorder
			} else if (
				(source.droppableId === quadroKanbanEnum.HL_PRONTAS.id &&
					destination.droppableId === quadroKanbanEnum.HL_EXECUTANDO.id) ||
				(source.droppableId === quadroKanbanEnum.HL_PRONTAS.id &&
					destination.droppableId === quadroKanbanEnum.HL_BLOCOS.id) ||
				(source.droppableId === quadroKanbanEnum.HL_PRONTAS.id &&
					destination.droppableId === quadroKanbanEnum.HL_PENDENTES.id) ||
				(source.droppableId === quadroKanbanEnum.HL_EXECUTANDO.id &&
					destination.droppableId === quadroKanbanEnum.HL_BLOCOS.id) ||
				(source.droppableId === quadroKanbanEnum.HL_PENDENTES.id &&
					destination.droppableId === quadroKanbanEnum.HL_BLOCOS.id) ||
				(source.droppableId === quadroKanbanEnum.HL_PENDENTES.id &&
					destination.droppableId === quadroKanbanEnum.HL_PRONTAS.id)
			) {
				// remove
			} else if (
				(source.droppableId === quadroKanbanEnum.HL_EXECUTANDO.id &&
					destination.droppableId === quadroKanbanEnum.HL_PRONTAS.id) ||
				(source.droppableId === quadroKanbanEnum.HL_EXECUTANDO.id &&
					destination.droppableId === quadroKanbanEnum.HL_PENDENTES.id) ||
				(source.droppableId === quadroKanbanEnum.HL_PENDENTES.id &&
					destination.droppableId === quadroKanbanEnum.HL_EXECUTANDO.id) ||
				(source.droppableId === quadroKanbanEnum.HL_PRONTAS.id &&
					destination.droppableId === quadroKanbanEnum.HL_EXECUTANDO.id) ||
				(source.droppableId === quadroKanbanEnum.HL_PRONTAS.id &&
					destination.droppableId === quadroKanbanEnum.HL_PENDENTES.id)
			) {
				if (bloco.data.bloqueado === 'S') {
					this.props.commonActions.showAlerta(
						'erro',
						`${this.props.intl.formatMessage({ id: "dashboards.histology.blockedNonconformity" })}`,
						2000
					);
				} else {
					this.move(source, destination);
				}
			} else {
				if (bloco.data.bloqueado === 'S') {
					this.props.commonActions.showAlerta(
						'erro',
						`${this.props.intl.formatMessage({ id: "dashboards.histology.blockedNonconformity" })}`,
						2000
					);
				} else {
					var tipo = UteisHistologia.getTipoLamina(bloco.data.tipoBloco, this.props.intl);
					var data = {
						nrBloco: bloco.data.nrBloco,
						blocoID: bloco.data.id,
						laudoID: bloco.data.cdLaudo,
						medicoID: null,
						tecnicoID: this.usuario.usuarioId,
						sentinelaMama: false,
						sentinelaMelanoma: false,
						complemento: '',
						laminas: [
							{
								lamina: tipo.nome,
								qtd: 1
							}
						]
					};
					this.props.commonActions.showFadeCarregando(true);
					HistologiaApi.criarLamina(data)
						.then(result => {
							this.props.commonActions.showAlerta(
								'sucesso',
								`${this.props.intl.formatMessage({ id: "dashboards.histology.bladeSuccessfullyRequested" })}`,
								2000
							);
							this.props.commonActions.showFadeCarregando(false);

							this.filtrar(
								!!this.state.tecnicoSelecionado
									? this.state.tecnicoSelecionado.value
									: null,
								this.state.periodoInicial,
								this.state.periodoFinal,
								this.state.numeroDoExame
							);
						})
						.catch(error => {
							this.props.commonActions.showAlerta(
								'error',
								`${this.props.intl.formatMessage({ id: "dashboards.histology.errorWritingBlades" })}`,
								800
							);
						});
				}
			}
		}
	}

	move(source, destination) {
		let lista = cloneDeep(this.state.lista);
		let origem = lista.find(e => Object.keys(e)[0] === source.droppableId);
		let destino = lista.find(
			e => Object.keys(e)[0] === destination.droppableId
		);
		let movido = origem[source.droppableId].splice(source.index, 1)[0];

		var icone = quadroKanbanEnum.HL_PENDENTES.icone;
		var status = quadroKanbanEnum.HL_PENDENTES.status;
		if (destination.droppableId === quadroKanbanEnum.HL_EXECUTANDO.id) {
			icone = quadroKanbanEnum.HL_EXECUTANDO.icone;
			status = quadroKanbanEnum.HL_EXECUTANDO.status;
		} else if (destination.droppableId === quadroKanbanEnum.HL_PRONTAS.id) {
			icone = quadroKanbanEnum.HL_PRONTAS.icone;
			status = quadroKanbanEnum.HL_PRONTAS.status;
		}

		HistologiaApi.updateLamina(movido.data.id, status)
			.then(result => {
				destino[destination.droppableId].splice(
					destination.index,
					0,
					this.montemItemKanbanLamina(
						movido.data,
						icone,
						destination.droppableId
					)
				);

				let altura = this.calcularAlturaColunaKanbam(lista);

				this.props.commonActions.showAlerta(
					'sucesso',
					`${this.props.intl.formatMessage({ id: "dashboards.cytology.bladesCreated" })}`,
					800
				);

				lista[0]['count'] = lista[0][quadroKanbanEnum.HL_BLOCOS.id].length;
				lista[1]['count'] = lista[1][quadroKanbanEnum.HL_PENDENTES.id].length;
				lista[2]['count'] = lista[2][quadroKanbanEnum.HL_EXECUTANDO.id].length;
				lista[3]['count'] = lista[3][quadroKanbanEnum.HL_PRONTAS.id].length;

				this.setState({ lista, altura });
			})
			.catch(error => {
				this.props.commonActions.showAlerta(
					'erro',
					`${this.props.intl.formatMessage({ id: "dashboards.cytology.bladesNotMoved" })}`,
					1500
				);
			});
	}

	toggleModal(droppableId) {
		if (this.state.modalOpen) {
			this.setState({ modalOpen: false });
			this.filtrar(
				!!this.state.tecnicoSelecionado
					? this.state.tecnicoSelecionado.value
					: null,
				this.state.periodoInicial,
				this.state.periodoFinal,
				this.state.numeroDoExame
			);
		} else {
			this.setState({ modalOpen: true });
		}

		this.setState({
			blocoSelecionado: undefined,
			medicoSelecionado: undefined,
			tecnicoModalSelecionado: undefined,
			tipoLaminaBloco: undefined,
			modalDroppableId: droppableId
		});
	}

	toggleModalCancelar() {
		if (this.state.modalOpenCancelar) {
			this.setState({ modalOpenCancelar: false });
			this.filtrar(
				!!this.state.tecnicoSelecionado
					? this.state.tecnicoSelecionado.value
					: null,
				this.state.periodoInicial,
				this.state.periodoFinal,
				this.state.numeroDoExame,
				 this.state.sortAsc
			);
		} else {
			this.setState({ modalOpenCancelar: true });
		}
	}

	toggleModalNaoConfor() {
		if (this.state.modalOpenNaoConfor) {
			this.setState({ modalOpenNaoConfor: false });
			this.filtrar(
				!!this.state.tecnicoSelecionado
					? this.state.tecnicoSelecionado.value
					: null,
				this.state.periodoInicial,
				this.state.periodoFinal,
				this.state.numeroDoExame,
				this.state.sortAsc
			);
		} else {
			this.setState({ modalOpenNaoConfor: true });
		}
	}

	onChangeNumeroExame(event) {
		this.setState({
			numeroDoExame: event.currentTarget.value
		});
	}

	onClickOrdem(){
		this.setState({sortAsc : !this.state.sortAsc});
	}

	onKeyPressNumeroExame(event) {
		let {
			periodoInicial,
			periodoFinal,
			tecnicoSelecionado,
			numeroDoExame
		} = this.state;

		if (event.key === 'Enter') {
			this.filtrar(
				!!tecnicoSelecionado ? tecnicoSelecionado.value : null,
				periodoInicial,
				periodoFinal,
				numeroDoExame,
				this.state.sortAsc
			);
		}
	}

	onChangeNumeroPedido(event) {
		this.setState({
			numeroDoPedido: event.currentTarget.value
		});
	}

	onKeyPressNumeroPedido(event) {
		let {
			periodoInicial,
			periodoFinal,
			tecnicoSelecionado,
			numeroDoExame,
			numeroDoPedido
		} = this.state;

		if (event.key === 'Enter') {
			this.filtrar(
				!!tecnicoSelecionado ? tecnicoSelecionado.value : null,
				periodoInicial,
				periodoFinal,
				numeroDoExame,
				numeroDoPedido,
				this.state.sortAsc
			);
		}
	}

	render() {
		const { numeroDoExame, numeroDoPedido, altura } = this.state;

		return (
			<div>
				<Preview
					show={this.state.show}
					setShow={this.setShow.bind(this)}
					url={this.state.url}
				/>
				<LaminasPage
					limparFiltro={this.limparFiltro.bind(this)}
					match={this.props.match}
					history={this.props.history}
					lista={this.state.lista}
					itemInModal={this.state.itemInModal}
					modalOpen={this.state.modalOpen}
					usuarioLocal={this.state.usuarioLocal}
					modalOpenCancelar={this.state.modalOpenCancelar}
					modalOpenNaoConfor={this.state.modalOpenNaoConfor}
					naoconformidades={this.state.naoconformidades}
					blocoSelecionado={this.state.blocoSelecionado}
					tipoLaminaBloco={this.state.tipoLaminaBloco}
					enableSentinela={this.state.enableSentinela}
					onDragEndOverride={this.onDragEndOverride.bind(this)}
					toggleModal={this.toggleModal.bind(this)}
					toggleModalCancelar={this.toggleModalCancelar.bind(this)}
					toggleModalNaoConfor={this.toggleModalNaoConfor.bind(this)}
					tecnicoSelecionado={this.state.tecnicoSelecionado}
					tecnicos={this.state.tecnicos}
					medicos={this.state.medicos}
					periodoInicial={this.state.periodoInicial}
					periodoFinal={this.state.periodoFinal}
					onChangeData={this.onChangeData.bind(this)}
					onChangeTecnico={this.onChangeTecnico.bind(this)}
					onChangeNumeroExame={this.onChangeNumeroExame.bind(this)}
					onKeyPressNumeroExame={this.onKeyPressNumeroExame.bind(this)}
					onClickOrdem={this.onClickOrdem.bind(this)}
					sortAsc={this.state.sortAsc}
					numeroDoExame={numeroDoExame}
					altura={altura}
					laminasParaEtiqueta={this.state.laminasParaEtiqueta}
					showModalImprimirEtiquetaEmLote={this.state.showModalImprimirEtiquetaEmLote}
					toggleModalImprimirEtiquetaEmLote={this.toggleModalImprimirEtiquetaEmLote.bind(this)}
					imprimirEtiquetaEmLote={this.imprimirEtiquetaEmLote.bind(this)}
					buscar={this.buscar.bind(this)}
					organizar={this.organizar.bind(this)}
					openModalBlocos={this.modalEditBlocoControl.bind(this)}
					modalHistologiaBlocos={this.state.modalHistologiaBlocos}
					commonActions={this.props.commonActions}
					periodos={this.state.periodos}
					periodo={this.state.periodo}
					onChangePeriodo={this.periodoAlterado.bind(this)}
					mudarIntervaloPeriodo={this.mudarIntervaloPeriodo.bind(this)}
					onKeyPressData={this.eventoOnKeyPressData.bind(this)}
					onChangeNumeroPedido={this.onChangeNumeroPedido.bind(this)}
					onKeyPressNumeroPedido={this.onKeyPressNumeroPedido.bind(this)}
					numeroDoPedido={numeroDoPedido}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		novasLaminas: state.kanban.novasLaminas,
		organizarLotenovasLaminas: state.organizarLote.novasLaminas
	};
};

const mapDispatchToProps = dispatch => {
	return {
		commonActions: bindActionCreators(commonActions, dispatch),
		kanbanActions: bindActionCreators(kanbanActions, dispatch),
		organizarActions: bindActionCreators(organizarActions, dispatch)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LaminasContainer);



// WEBPACK FOOTER //
// ./src/pages/histologia/laminas/laminas.container.js